import { InjectionToken } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LeapOnboardingStatusResponse } from './leap-api.service';

export interface LeapOnboardingData {
	leapUserId: string;
	leapFirmId: string;
	accessToken: string;
	code?: string;
	isForFirm: boolean;
}

export interface ILeapOnboardingService {
	isLoading$: BehaviorSubject<boolean>;
	onboardingStatusResponse: LeapOnboardingStatusResponse;
	userAccountBelongsToDifferentBusinessError$: BehaviorSubject<{
		hasError: boolean;
		invalidEmail: string;
	}>;
	goToWelcomeScreen(): void;
	goToConfirmationScreen(): void;
	goToUpdateLeapReminderScreen(): void;
	goToLoginScreen: () => void;
	subscribeToSetUser: () => Promise<void>;
	connect(email?: string, businessId?: string): Promise<void>;
}

export const LEAP_ONBOARDING_SERVICE =
	new InjectionToken<ILeapOnboardingService>('LEAP_ONBOARDING_SERVICE');
